export const ALLOWED_PRODUCT_QUERY_PARAMS = [
    'color',
    'includePools',
    'trim',
    'productId',
    'quantity',
    'reviewPage',
    'size',
    'slug',
    'styleNumber',
    'type'
];
